import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

const HelpPage = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/content/help1.md')
      .then(res => res.text())
      .then(text => setContent(text));
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default HelpPage;